export const DISCORD_URL = 'https://discord.gg/597zABqter';

export const TWITTER_URL = 'https://twitter.com/AlterNovaXYZ';
